import Close from '@sfly/uig-svg-icon/action/close'

const CloseIcon = () => {
    return (<label className="close-icon">
        <Close/>
    </label>)
}

export default CloseIcon;